import {useDispatch, useSelector} from "react-redux";
import {Animate} from "react-simple-animate";
import {unwrapResult} from '@reduxjs/toolkit';
import {useState} from "react";
import ProgressBar from "../../../Components/ProgressBar";
import {setCorporateIsActive, setIndividualIsActive} from "../../../../Features/Misc/accountTypeSlice";
import {incrementLoginStep} from "../../../../Features/Misc/loginSlice";
import {setEmailVerified} from "../../../../Features/Auth/authSlice";

// import "../../CheckOutForm.css"

import {
    sendEmail,
    setCorporateUser,
    setIndividualUser,
    setKipMateCode,
    setFirst_name,
    setLast_name,
    setEmail,
    setPassword,
    setConfirmPassword,
    setPasswordType,
    setConfirmPasswordType,
    setOneTimeCode,
    checkCouponValidity
} from "../../../../Features/Auth/authSlice"
// import axios from "axios";

const useCode = process.env.REACT_APP_USE_CODE_4 === 'true';
// console.log(typeof(useCode))

export default function SignupForm() {

    //Redux slice states
    const {
        individualIsActive,
        corporateIsActive,

    } = useSelector((state) => state.accountType)


    const userNames = useSelector(state => state.auth.usernames)

    const {
        kipMateCode,
        first_name,
        last_name,
        email,
        password,
        passwordType,
        confirmPassword,
        confirmPasswordType,
        // couponIsValid,
        // couponErrorMessage //if this exists, add to error message array
    } = useSelector((state) => state.auth)

    const [formErrors, setFormErrors] = useState([]);
    const dispatch = useDispatch();

    const validateForm = async () => {
        setFormErrors((prevErrors) => []);
        const errors = [];
        let userEmails = [];


        //Kipmate code validation
        try {
            if (corporateIsActive) {
                const actionResult = await dispatch(checkCouponValidity(kipMateCode));
                const payload = unwrapResult(actionResult);
                if (!payload.valid) {
                    errors.push(payload.message)
                }
            }
        } catch (error) {
            console.error("API call error:", error);
            errors.push("An error occurred validating your coupon - contact us");
        }

        //name validation
        if (first_name === 'First Name') {
            errors.push('You need to enter a first name.')
        }

        if (last_name === 'Surname') {
            errors.push('You need to enter a surname.')
        }

        if (userNames.includes(email)) {
            errors.push("This email is already registered.");
        }

        //email validation
        // try {
        //     const getCustomerData = await axios.get(`https://kipmate.com/manage/wp-json/wc/v3/customers`, {
        //         auth: {
        //             'username' : process.env.REACT_APP_WP_USERNAME,
        //             'password' : process.env.REACT_APP_WP_PASSWORD
        //         },
        //     });
        //
        //     userEmails = getCustomerData.data.map((customer) => customer.email);
        //
        // } catch (error) {
        //     console.error("API call error:", error);
        //     errors.push("An error occurred validating your email address.");
        // }

        const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;

        if (!emailRegex.test(email)) {
            errors.push("You must use a valid email address");
        } else if (userEmails.includes(email)) {
            errors.push("This email address has already been used.");
        }

        //password validation
        if (password.length < 8) {
            errors.push("Password must be 8 characters or more.");
        }

        if (password !== confirmPassword) {
            errors.push("Password and password confirmation do not match.");
        }

        return errors;
    }

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const pass = Math.floor(1000 + Math.random() * 9000);
            if(useCode === true) {
                dispatch(setOneTimeCode(pass));
            }

            const newFormErrors = await validateForm();

            setFormErrors(newFormErrors);

            if (newFormErrors.length === 0) {
                const sendData = {
                    to: email,
                    text: pass
                };
                if(useCode === true){
                    dispatch(sendEmail(sendData));
                }
                if(useCode === false){
                    // console.log("setting email verified to true on the form")
                    dispatch(setEmailVerified());
                }

                dispatch(incrementLoginStep());
            }
        } catch (error) {
            console.log(error.message);
        }
    }


    // const handleCouponErrorClick = () => {
    //     // Your logic to handle the coupon error click, for example:
    //     // Navigate to the coupon information page or display a modal with coupon info
    //     // console.log("Coupon error link clicked");
    // };


    const inputStyles = "bg-purple-dashboard  focus:outline-none focus:border-pink-icon text-unfocused-text border-dark-pink rounded-lg border-2 h-14 px-4 py-2"

    return (

        <form
            className="lg:col-start-1 lg:col-end-13 col-start-2 col-end-12 lg:row-start-1 row-start-2 row-end-13 text-xl text-white ">
            <Animate play start={{opacity: 0}}
                     end={{opacity: 1, display: "flex", flexDirection: "column", gap: "0.625rem"}} duration={0.7}>

                <div className="text-base mb-4">
                    {
                        formErrors.length < 1 ?
                            <p>Signing up for a Corporate account or Individual account?</p>
                            :
                            formErrors.map((errors, index) =>
                                (<p key={index} className={`text-gold-accent`} style={{margin: 0}}>{errors}</p>))
                    }
                </div>


                <div className="flex flex-row gap-4 w-full text-unfocused-text ">
                    <div onClick={() => {
                        dispatch(setCorporateIsActive());
                        dispatch(setCorporateUser());
                    }}
                         className={` ${corporateIsActive ? " border-light-pink " : " border-dark-pink"} rounded-lg border-2 px-4 py-2 h-14 flex flex-row gap-4 w-1/2`}>
                        {corporateIsActive ? <i className={`ri-checkbox-circle-fill`}/> :
                            <i className={`ri-checkbox-blank-circle-line`}/>}
                        <div>Corporate</div>
                    </div>
                    <div onClick={() => {
                        dispatch(setIndividualIsActive());
                        dispatch(setIndividualUser());
                    }}
                         className={` ${individualIsActive ? " border-light-pink " : " border-dark-pink"} rounded-lg border-2 px-4 py-2 h-14 flex flex-row gap-4 cursor-pointer w-1/2`}>
                        {individualIsActive ? <i className={`ri-checkbox-circle-fill`}/> :
                            <i className={`ri-checkbox-blank-circle-line`}/>}
                        <div>Individual</div>
                    </div>
                </div>

                {corporateIsActive && <>

                    <input
                        type={"text"}
                        placeholder={kipMateCode}
                        value={kipMateCode}
                        onClick={() => {
                            if (kipMateCode === "kipmate code") {
                                dispatch(setKipMateCode(""))
                            }
                        }}
                        onChange={e => {
                            dispatch(setKipMateCode(e.target.value));
                            // console.log(kipMateCode)
                        }}
                        onBlur={() => {
                            if (kipMateCode === "") {
                                dispatch(setKipMateCode("kipmate code"))
                            }
                        }}
                        className={inputStyles}
                    />

                        <p className="text-gold-accent -mb-1 -mt-1 text-sm">
                            Not got a code? Contact us at <a href="mailto:kipbetter@kipmate.com?subject=Request for Kipmate Code" className="underline cursor-pointer">kipbetter@kipmate.com</a>
                        </p>

                </>
                }

                <input
                    type={"text"}
                    placeholder={first_name}
                    value={first_name}
                    onClick={() => {
                        if (first_name === "First Name") {
                            dispatch(setFirst_name(""))
                        }
                    }}
                    onChange={e => dispatch(setFirst_name(e.target.value))}
                    onBlur={() => {
                        if (first_name === "") {
                            dispatch(setFirst_name("First Name"))
                        }
                    }}
                    className={inputStyles}
                />

                <input
                    type={"text"}
                    placeholder={last_name}
                    value={last_name}
                    onClick={() => {
                        if (last_name === "Surname") {
                            dispatch(setLast_name(""))
                        }
                    }}
                    onChange={e => dispatch(setLast_name(e.target.value))}
                    onBlur={() => {
                        if (last_name === "") {
                            dispatch(setLast_name("Surname"))
                        }
                    }}
                    className={inputStyles}
                />

                <input
                    type={"email"}
                    placeholder={email}
                    value={email}
                    onClick={() => {
                        if (email === "Email") {
                            dispatch(setEmail(""))
                        }
                    }}
                    onChange={e => dispatch(setEmail(e.target.value))}
                    onBlur={() => {
                        if (email === "") {
                            dispatch(setEmail("Email"))
                        }
                    }}
                    className={inputStyles}
                />

                <input
                    type={passwordType}
                    placeholder={password}
                    value={password}
                    onFocus={() => {
                        if (password === "Password" && passwordType === "text") {
                            dispatch(setPassword(""));
                            dispatch(setPasswordType("password"))
                        }
                    }}
                    onChange={e => dispatch(setPassword(e.target.value))}
                    onBlur={() => {
                        if (password === "") {
                            dispatch(setPassword("Password"));
                            dispatch(setPasswordType("text"))
                        }
                    }}
                    className={inputStyles}
                />

                <input
                    type={confirmPasswordType}
                    placeholder={confirmPassword}
                    value={confirmPassword}
                    onFocus={() => {
                        if (confirmPassword === "Confirm Password" && confirmPasswordType === "text") {
                            dispatch(setConfirmPassword(""));
                            dispatch(setConfirmPasswordType("password"))
                        }
                    }}
                    onChange={e => dispatch(setConfirmPassword(e.target.value))}
                    onBlur={() => {
                        if (confirmPassword === "") {
                            dispatch(setConfirmPassword("Confirm Password"));
                            dispatch(setConfirmPasswordType("text"))
                        }
                    }}
                    className={inputStyles}
                />

                <button onClick={handleSubmit}
                        className="bg-gold-accent hover:bg-gold-accent-hover text-white/75 h-14 px-4 py-2 rounded-lg ">Sign
                    Up
                </button>

                <ProgressBar width={"w-8"} attachLoginQuery={true}/>
            </Animate>

        </form>
    );
}















